<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar title="音频详情" left-arrow fixed :z-index="99" @click-left="onClickLeft" :border="false">
      <!-- <template #right>
        <van-icon name="share" @click="shareHandler"/> 
      </template> -->
    </van-nav-bar>
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
    	<!-- <audio controls="controls" src="http://music.reborndata.com/music/201712/20171212/201712121741057328.mp3" id="audio"></audio> -->
    	<div class="audio-player">
    		<aplayer autoplay theme="#24a378"
    		  :music="{
    		    title: '记录这一刻',
    		    artist: '无名',
    		    src: 'http://music.reborndata.com/music/201712/20171212/201712121741057328.mp3',
    		    pic: 'https://img.yzcdn.cn/vant/cat.jpeg'
    		  }"
    		/>
    	</div>
      <div class="audio-title">333ex FCC</div>
      <p class="audio-date">2020-03-05 10:48:51</p>
      
      <CommentBox />
      
      <div class="appbarSpace"></div>
      <div class="van-hairline--top appbarBottom">
      	<router-link to="" class="item">
      		<van-icon name="edit" />
      		<span class="text">编辑</span>
      	</router-link>
      	<router-link to="" class="item">
      		<van-icon name="envelop-o" />
      		<span class="text">发送</span>
      	</router-link>
      	<!-- <router-link to="" class="item">
      		<van-icon name="share" />
      		<span class="text">分享</span>
      	</router-link> -->
      	<router-link to="" class="item">
      		<van-icon name="delete" />
      		<span class="text">删除</span>
      	</router-link>
      </div>
    </div>
  </div>
</template>


<script>
	import soshm from 'soshm';
	import Aplayer from 'vue-aplayer';
	import CommentBox from '@/components/CommentBox.vue'
	export default {
	  data() {
	    return {
	    	
	    };
	  },
	  components: {
	  	Aplayer,
	  	CommentBox
    },
		methods :{
			onClickLeft() {
			  this.$router.go(-1)
			},
			/**推荐给朋友**/
			shareHandler(){
			  soshm.popIn({
			    title: '弹窗分享',
			    sites: ['weixin', 'weixintimeline', 'weibo', 'qzone', 'tqq', 'qq']
			  });
			},
		},
	};
</script>

<style scoped>
.audio-player{
	margin: 20px 15px;
}
.audio-title{
	text-align: center;
	font-size: 16px;
	margin-top: 28px;
	padding: 0 15px;
}
.audio-date{
	font-size: 12px;
	color: #bbb;
	text-align: center;
	padding: 0 15px;
}
</style>

